/* eslint-disable @typescript-eslint/no-explicit-any */
export const availableLangs = ['en', 'fr', 'es'];

export const scopeLoader = (
  importer: (lang: string, root: string) => any,
  root = 'i18n',
) => {
  return availableLangs.reduce((acc: any, lang) => {
    acc[lang] = () => importer(lang, root);
    return acc;
  }, {});
};
